import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const EditIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path
      fillRule="evenodd"
      d="m17.159 2.289-13.17 13.17.02 3.55 3.522-.021L20.694 5.824l-3.535-3.535ZM5.5 17.499l1.406-.008L18.573 5.824 17.159 4.41 5.492 16.078 5.5 17.5Z M22 20.5H2V22h20v-1.5Z"
    />
  </IconWrapper>
)

export default EditIconMedium
